import { render, staticRenderFns } from "./ApplyAsStartupDialog.vue?vue&type=template&id=9fd85476&"
import script from "./ApplyAsStartupDialog.vue?vue&type=script&lang=js&"
export * from "./ApplyAsStartupDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports